import { useQuery } from "@tanstack/react-query";
import { UsageAnalytics } from "@modules/usages/types";
import { getUsageAnalyticsService } from "./service";

export const usageAnalyticsQueryKey = ["usage_admin_analytics"];

export function useUsageAnalyticsQuery(filters?: Record<string, string>) {
  return useQuery<UsageAnalytics>({
    queryKey: usageAnalyticsQueryKey.concat(JSON.stringify(filters || {})),
    queryFn: () => getUsageAnalyticsService(filters),
  });
}
